import {
    START_FETCH_DESIGNATION,
    DESIGNATION_FETCH_SUCCESS,
    DESIGNATION_FETCH_FAILED,
} from "./types";
import axios from "axios";
import { BaseUrl } from "./api";
export const fetchDesignation = (token) => {
    return async (dispatch) => {
        dispatch({
            type: START_FETCH_DESIGNATION,
        });
        try {
            const res = await axios.get(`${BaseUrl}/designation`, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    dataType: "json",
                    Authorization: `Bearer ${token}`,
                },
            });
            if (res.statusText === "OK") {
                dispatch({
                    type: DESIGNATION_FETCH_SUCCESS,
                    payload: res.data,
                });
            } else {
                dispatch({
                    type: DESIGNATION_FETCH_FAILED,
                    payload: "fetching designation failed",
                });
            }
        } catch (error) {
            dispatch({
                type: DESIGNATION_FETCH_FAILED,
                payload: error.message,
            });
        }
    };
};
